import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-279b97b2"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  id: "category",
  "class": "item category"
};
var _hoisted_2 = {
  "class": "name"
};
var _hoisted_3 = {
  "class": "name"
};
var _hoisted_4 = {
  "class": "name"
};
var _hoisted_5 = {
  "class": "name"
};
var _hoisted_6 = {
  "class": "name"
};
var _hoisted_7 = {
  "class": "name"
};
import { DownOutlined } from "@ant-design/icons-vue";
import { ref, defineAsyncComponent, watch } from "vue";
import { useRoute } from "vue-router";
import { onBeforeRouteUpdate } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'nav-menu',
  props: ["mode"],
  setup: function setup(__props) {
    var Category = defineAsyncComponent(function () {
      return import("./category.vue");
    });
    var props = __props;
    var tabValue = ref("");
    var route = useRoute();
    var setTabValue = function setTabValue(val) {
      switch (val) {
        case "manufacturer":
        case "rfq":
        case "about-us":
        case "contact-us":
        case "blog":
        case "category":
        case "quality-control":
          tabValue.value = val;
          break;
        case "blog-detail":
          tabValue.value = "blog";
          break;
        default:
          tabValue.value = "";
      }
    };
    var isHover = ref(false);
    var openChange = function openChange(val) {
      isHover.value = !!val;
    };
    var _getPopupContainer = function getPopupContainer() {
      return document.getElementById("category");
    };
    onBeforeRouteUpdate(function (to) {
      var tabName = to.name;
      // debugger;
      setTabValue(tabName);
    });
    watch(function () {
      return route.path;
    }, function (newPath, oldPath) {
      var tabName = route.name;
      setTabValue(tabName);
    }, {
      immediate: true
    });
    return function (_ctx, _cache) {
      var _component_a_dropdown = _resolveComponent("a-dropdown");
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(["nav", {
          white: props.mode === 'white'
        }])
      }, [_createVNode(_component_a_dropdown, {
        "class": _normalizeClass(["dropdown", {
          active: tabValue.value === 'category'
        }]),
        overlayClassName: "dropdown-overlay",
        onOpenChange: openChange,
        getPopupContainer: function getPopupContainer() {
          return _getPopupContainer();
        },
        placement: "bottom"
      }, {
        overlay: _withCtx(function () {
          return [_createVNode(_unref(Category))];
        }),
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(_ctx.$t("Category")) + " ", 1), _createVNode(_unref(DownOutlined), {
            "class": _normalizeClass(["icon", {
              hover: isHover.value
            }])
          }, null, 8, ["class"])])])];
        }),
        _: 1
      }, 8, ["class", "getPopupContainer"]), _createVNode(_component_router_link, {
        "class": _normalizeClass(["item", {
          active: tabValue.value === 'manufacturer'
        }]),
        to: {
          name: 'manufacturer'
        }
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("Manufacturers")), 1)];
        }),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        "class": _normalizeClass(["item", {
          active: tabValue.value === 'rfq'
        }]),
        to: {
          name: 'rfq'
        }
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("RFQ")), 1)];
        }),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        "class": _normalizeClass(["item", {
          active: tabValue.value === 'blog'
        }]),
        to: {
          name: 'blog'
        }
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("Blog")), 1)];
        }),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        "class": _normalizeClass(["item", {
          active: tabValue.value === 'quality-control'
        }]),
        to: {
          name: 'quality-control'
        }
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("Quality Control")), 1)];
        }),
        _: 1
      }, 8, ["class"]), _createVNode(_component_router_link, {
        "class": _normalizeClass(["item", {
          active: tabValue.value === 'about-us'
        }]),
        to: {
          name: 'about-us'
        }
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("About Us")), 1)];
        }),
        _: 1
      }, 8, ["class"])], 2);
    };
  }
});